import { isMocking, mockedEvent, getMockSocket } from 'api/mockupUtils'

export default socket => ({
    updatePlayer: data => {
        console.tron.log('SOCKET EMMIT - update_player')
        console.tron.log(data)
        // socket.emit(mockedEvent('update_player'), isMocking ? getMockSocket('player_updated', { ok: true }) : data)
        socket.emit('update_player', data)
    }
})



// WEBPACK FOOTER //
// src/api/emitters/player.js